import React, { Component } from "react";
import Modal from "react-modal";
import {
  format,
  isToday,
  addWeeks,
  startOfMonth,
  endOfMonth,
  startOfWeek,
  endOfWeek,
  eachDayOfInterval,
} from "date-fns";
import styled from "styled-components";
import { Col, Row } from "styled-bootstrap-grid";
import { ChevronLeft, ChevronRight } from "styled-icons/boxicons-regular";
import ProgressBar from "react-bootstrap/ProgressBar";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  dateFormat,
  TimeConverstion,
} from "../../../../Api/Utils/ReuseableFunctions";
import { withTranslation, Trans } from "react-i18next";
import ProfilePic from "../../../App/Header/profile-pic-header.png";
import CalloutIcon from "../add comments.svg";
function getMonthData(currentDate, data) {
  const monthName = format(currentDate, "MMMM");
  let monthArray = eachDayOfInterval({
    start: startOfWeek(startOfMonth(currentDate), { weekStartsOn: 1 }),
    end: addWeeks(endOfWeek(endOfMonth(currentDate), { weekStartsOn: 1 }), 1),
  });
  monthArray = monthArray.length > 42 ? monthArray.slice(0, 42) : monthArray;
  let monthData = data.filter((obj) => obj.month === monthName);
  monthArray = monthArray.map((date) => {
    const dateObj = {};
    dateObj.disableDate = format(date, "MMMM") !== monthName;
    dateObj.dayVal = date;
    dateObj.dayData = getDaydata(date, monthData);
    dateObj.disableDate = dateObj.dayData ? dateObj.disableDate : true;
    return dateObj;
  });
  return monthArray;
}

function getDaydata(date, monthData) {
  const dateNo = date.getDate() - 1;
  const dateString = format(date, "dd/MM/yyyy");
  let month =
    monthData.length > 0 && monthData[0].otherDetailsResponseList
      ? monthData[0].otherDetailsResponseList
      : [];
  if (month[dateNo] && month[dateNo].timesheetDate === dateString) {
    return month[dateNo];
  } else {
    return null;
  }
}

class MonthView extends Component {
  constructor(props) {
    super(props);

    Modal.defaultStyles.overlay.backgroundColor = "rgb(72, 73, 75,0.9)";
    this.state = {
      currentDate: "",
      weekNames: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
      calenderData: undefined,
    };
  }
  //
  componentDidUpdate(nextProps) {
    if (this.props.monthData !== nextProps.monthData) {
      const currentDate = dateFormat(
        this.props.monthData.payload.otherDetailsResponseList[0].timesheetDate
      );
      this.setState({
        currentDate: currentDate,
        calenderData: getMonthData(currentDate, [this.props.monthData.payload]),
      });
      this.props.date(currentDate);
    }
  }

  render() {
    const {
      monthData,
      security
    } = this.props;
    return this.state.calenderData !== void 0 ? (
      <ParentDiv>
        <Row className="head-row">
          <ProfileImage md={6}>
            {this.props.userDefault.emplRole === "Workshop Manager" ||
              this.props.userDefault.emplRole === "Workshop Admin" ? (
                <>
                  <img src={ProfilePic} alt="profileimage" />
                  <label>{monthData.payload.emplName}</label>
                </>
              ) : null}
          </ProfileImage>
          <Time4timeBank md={6}>
            {security !== void 0 && security.showTimeForTimeBank !== "N" && (
              <ul>
                <li>
                  <Trans>time4TimeBanked</Trans>
                </li>
                <li>
                  {monthData.payload.time4TimeBank
                    ? TimeConverstion(monthData.payload.time4TimeBank)
                    : "00"}
                </li>
              </ul>
            )}
          </Time4timeBank>
        </Row>
        <ButtonLeft type="button" onClick={this.props.previousMonth}>
          {" "}
          <Caretleft size="24" />
        </ButtonLeft>
        <MonthSpan>
          <Trans>{format(this.state.currentDate, "MMM").toLowerCase()}</Trans>{" "}
          {format(this.state.currentDate, "yyyy")}
        </MonthSpan>
        <ButtonRight type="button" onClick={this.props.nextMonth}>
          <Caretright size="24" />
        </ButtonRight>
        <WeekDayNames>
          {this.state.weekNames.map((names) => (
            <div key={names} sm="1">
              <Trans>{names}</Trans>
            </div>
          ))}
        </WeekDayNames>
        <MonthName>
          {this.state.calenderData.map((dateObj, dayindex) => {
            let standByFlag = this.returnStandBy(
              dateObj,
              dayindex,
              this.state.calenderData
            );

            return (
              <ColDay key={dayindex}>
                {!dateObj.disableDate ? (
                  this.monthEmployeeData(dateObj, standByFlag)
                ) : (
                    <EmployeeDataDiv isdisabled={dateObj.disableDate}>
                      {this.monthDateView(dateObj)}
                    </EmployeeDataDiv>
                  )}
              </ColDay>
            );
          })}
        </MonthName>
      </ParentDiv>
    ) : (
        <div />
      );
  }

  returnStandBy = (dateObj, dayindex, calenderData) => {
    let standByValue =
      dateObj && dateObj.dayData
        ? dayindex !== 0
          ? dayindex % 7 === 0
            ? !calenderData[dayindex - 1].dayData.isStandBy === "Y"
            : calenderData[dayindex - 1].dayData &&
            calenderData[dayindex - 1].dayData.isStandBy === "Y"
          : false
        : false;
    return standByValue;
  };
  monthEmployeeData = (dateObj, standByFlag) => {
    return (
      <>
        <EmployeeDataDiv
          isdisabled={dateObj.disableDate}
          value={dateObj.dayData.isApproved}
          Hold={dateObj.dayData.isOnHold}
          Holiday={dateObj.dayData.isHoliday}
          onClick={() => this.props.openDayDetails(dateObj)}
        >
          {this.monthDateView(dateObj)}
          {dateObj.dayData.callOuts.length > 0 &&
            dateObj.dayData.callOuts[0].callOutHours !== 0 && (
              <CallOutIcon>
                <img src={CalloutIcon} alt={"callouts"} />
              </CallOutIcon>
            )}
          {dateObj.dayData.totalAddntlCallOutHours ? (
            <React.Fragment>
              <HourSpan>
                {TimeConverstion(dateObj.dayData.totalAddntlCallOutHours)}
              </HourSpan>
            </React.Fragment>
          ) : null}
          {dateObj.dayData.isHoliday === "Y" && (
            <Holiday>
              <Trans>publicHoliday</Trans>
            </Holiday>
          )}
          {dateObj.dayData.isStandBy === "Y" && (
            <Onstandby>
              {!standByFlag && (
                <StandbySpan>
                  <Trans>standBy</Trans>
                </StandbySpan>
              )}
              <Progressbar striped variant="warning" now={100} />
            </Onstandby>
          )}
          {dateObj.dayData.isAbsent === "Y" && (
            <Absent>
              <Trans>{dateObj.dayData.absenceType}</Trans>
            </Absent>
          )}
        </EmployeeDataDiv>
      </>
    );
  };

  monthDateView = (dateObj) => {
    return startOfMonth(dateObj.dayVal).getDate() ===
      dateObj.dayVal.getDate() ? (
        <DatesSpan>{format(dateObj.dayVal, "dd MMM")}</DatesSpan>
      ) : (
        <DatesSpan isToday={isToday(dateObj.dayVal)}>
          {format(dateObj.dayVal, "dd")}
        </DatesSpan>
      );
  };
}
const mapStateToProps = ({
  auth,
  userMessage,
  monthData,
  fetchTimesheetSecurity,
}) => {
  return {
    isAuthenticated: auth.isAuthenticated,
    ssoId: auth.ssoId,
    message: userMessage,
    userDefault: auth.user.defaultProfile,
    monthData: monthData,
    security: fetchTimesheetSecurity.securityList,
  };
};

export default withRouter(
  connect(mapStateToProps)(withTranslation()(MonthView))
);
const ProfileImage = styled(Col)`
  position: relative;
  text-align: left;
  && label {
    padding-left: 15px;
  }
`;
const Time4timeBank = styled(Col)`
  text-align: right;
  && ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
  }
`;
const ParentDiv = styled.div`
  font-family: Trebuchet MS;
  max-width: 1010px;
  min-width: 700px;
  width: 90%;
  margin: 0 auto;
  .head-row {
    margin-bottom: -35px;
    line-height: 22px;
    height: 45px;
  }
`;
const ButtonLeft = styled.button`
  position: relative;
  right: 17px;
  top: 1px;
  border-radius: 20px;
  height: 24px;
  width: 24px;
  :focus {
    outline: 0;
    box-shadow: none !important;
  }
`;
const ButtonRight = styled.button`
  position: relative;
  left: 17px;
  top: 1px;
  border-radius: 20px;
  height: 24px;
  width: 24px;
  border: none;
  outline: none;
  :focus {
    outline: 0;
    box-shadow: none !important;
  }
`;
const Caretleft = styled(ChevronLeft)`
  position: relative;
  right: 8px;
  bottom: 4px;
  background: #babec3;
  border-radius: 20px;
`;
const Caretright = styled(ChevronRight)`
  position: relative;
  right: 8px;
  bottom: 4px;
  background: #babec3;
  border-radius: 20px;
`;
const MonthSpan = styled.span`
  font-size: 16px;
`;
const WeekDayNames = styled.div`
  margin: 20px 0 0 0;
  display: grid;
  grid-template-columns: repeat(7, auto);
  grid-template-rows: repeat(1, 20px);
  font-size: 16px;
`;
const MonthName = styled.div`
  margin: 10px 0;
  display: grid;
  grid-template-columns: repeat(7, 14.28%);
  grid-template-rows: repeat(6, 80px);
  box-shadow: 1px 3px 8px 3px #eaeaea;
  overflow-y: auto;
  @media (max-height: 720px) {
    max-height: 400px;
  }
`;
const ColDay = styled(Col)`
  display: table;
  padding: 0;
  position: relative;
  width: 100%;
  height: 100%;
  border: 1px solid #ddd;
  text-align: center;
`;
const EmployeeDataDiv = styled.div`
  height: 100%;
  width: 100%;
  display:table-cell;
  vertical-align:middle;
  padding-top: 8px;
  background: ${(props) =>
    props.Holiday === "Y"
      ? "#ABCCD4"
      : props.Hold === "Y"
        ? "#e65853"
        : props.value === "N"
          ? "white"
          : props.value === undefined
            ? "white"
            : "#7ce397"};
    cursor : pointer
    disable : ${(props) => (props.isdisabled ? true : false)}
    opacity : ${(porps) => (porps.isdisabled ? "0.4" : "none")}
`;
const DatesSpan = styled.div`
  font-size: 13px;
  position: absolute;
  font-weight: 649;
  background: #2b84e0;
  height: 20px;
  line-height: 18px;
  width: ${(props) => (props.isToday ? "20px" : "50px")};
  border-radius: 68px;
  top: 4px;
  left: 8px;
  color: ${(props) => (props.isToday ? "white" : "black")};
  background: ${(props) => (props.isToday ? " #2b84e0" : "None")};
  padding-top: 2px;
  text-align: left;
  text-align: ${(props) => (props.isToday ? "center" : "left")};
  padding-right: 0px;
`;

const HourSpan = styled.span`
  color: #333333;
  font-size: 24px;
`;
const CallOutIcon = styled.div`
  height: 20px;
  position: absolute;
  right: 5px;
  width: 20px;
  top: 0px;
`;
const Onstandby = styled.div`
  position: absolute;
  width: 100%;
  bottom: 1px;
`;
const Holiday = styled.div`
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  bottom: 7px;
  font-size: 14px;
`;
const Absent = styled.div`
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
`;
const Progressbar = styled(ProgressBar)`
  && {
    height: 12px;
    border-radius: 3px;
    margin: 0 -1px 0 -2px;
  }
`;

const StandbySpan = styled.span`
  position: relative;
  top: 17px;
  right: 30%;
  font-size: 12px;
  font-family: Trebuchet MS;
`;
